/* =========================================================
   PRÉSENZA — Core Theme JS
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Scroll-triggered animations ---------- */
  function initScrollAnimations() {
    var items = document.querySelectorAll('[data-animate]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Cart drawer ---------- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var openTriggers = document.querySelectorAll('[data-cart-toggle]');
    var closeTriggers = drawer.querySelectorAll('[data-cart-close], [data-cart-overlay]');

    function open() { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { drawer.hidden = true; document.body.style.overflow = ''; }

    openTriggers.forEach(function (btn) { btn.addEventListener('click', open); });
    closeTriggers.forEach(function (el) { el.addEventListener('click', close); });

    /* Intercept product card / product page add-to-cart forms for AJAX add */
    document.body.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshCartDrawer(); })
        .then(function () { open(); })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });

    /* Quantity +/- buttons inside the drawer */
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]');
      if (!btn) return;
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var row = btn.closest('[data-cart-line]');
      var qtyEl = row ? row.querySelector('[data-cart-qty-value]') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
      var newQty = btn.hasAttribute('data-cart-qty-increase') ? currentQty + 1 : currentQty - 1;
      if (newQty < 0) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshCartDrawer(); })
        .catch(function (err) { console.error('Cart update failed', err); });
    });

    function refreshCartDrawer() {
      return fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('[data-cart-count-text]').forEach(function (el) {
            el.textContent = cart.item_count;
          });

          var itemsWrap = drawer.querySelector('[data-cart-items]');
          var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
          if (!itemsWrap) return cart;

          if (cart.item_count === 0) {
            itemsWrap.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
          } else {
            itemsWrap.innerHTML = cart.items.map(function (item, idx) {
              var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
                ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
                : '';
              return (
                '<div class="cart-drawer__item" data-cart-line="' + (idx + 1) + '">' +
                  '<img src="' + item.image + '" alt="" width="80" height="80" loading="lazy">' +
                  '<div class="cart-drawer__item-info">' +
                    '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
                    variantLine +
                    '<div class="cart-drawer__item-qty">' +
                      '<button data-cart-qty-decrease data-line="' + (idx + 1) + '" aria-label="Decrease quantity">-</button>' +
                      '<span data-cart-qty-value>' + item.quantity + '</span>' +
                      '<button data-cart-qty-increase data-line="' + (idx + 1) + '" aria-label="Increase quantity">+</button>' +
                    '</div>' +
                  '</div>' +
                  '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>'
              );
            }).join('');
          }
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          return cart;
        });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        ? amount + ' ' + window.Shopify.currency.active
        : amount;
    }
  }

  /* ---------- Wishlist (localStorage-free, session-based via window state) ---------- */
  function initWishlist() {
    var wishlist = {};
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-product-id');
        wishlist[id] = !wishlist[id];
        btn.classList.toggle('is-active', wishlist[id]);
      });
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollAnimations();
    initCartDrawer();
    initWishlist();
    initBackToTop();
  });
})();
